import { CUSTOM_ICONS } from '@nexelem/icons';
import { Duration } from 'date-fns';
import { Chip, DropdownMenu } from '@nexelem/components';
import { useCustomTranslation } from '../../../../../../hooks';
import { cn, wait } from '@nexelem/utils';
import { scaleDefaultFilters, useTimelineStore } from '../../store';
import { LocateProductionTask } from '../../hooks';
import { isCurrentGanttDateWithinRangeSelector, useGanttFilterStore } from '../../../hooks/useGanttFilterStore';
import { centerElement, ganttFormatters } from '../../utils';
import { useConfig } from '@nexelem/config';
import { useEffect } from 'react';

export type DateFormat = 'y' | 'M' | 'd' | 'w' | 'H:mm';

export type ScaleFilter = {
  label: string;
  measureType: keyof Duration;
  measureScale: number;
  dateFormat: DateFormat;
};

export const TimelineFilterChip = () => {
  const { modules } = useConfig();
  const isMonthScaleEnabled = modules.production.ganttMonthScale;
  const scrollContainer = document.getElementById(LocateProductionTask.scrollContainerId);
  const { tWrapper } = useCustomTranslation('components.timeline');

  const currentFilter = useTimelineStore((state) => state.filters.current);
  const onFilterChange = useTimelineStore((state) => state.handleFilterChange);
  const isCurrentDateWithinRange = useGanttFilterStore(isCurrentGanttDateWithinRangeSelector);

  const centerCurrentDate = async () => {
    if (isCurrentDateWithinRange && scrollContainer) {
      await wait(500);
      centerElement({ current: scrollContainer }, ganttFormatters.dateToSelector(new Date()));
    }
  };

  const filters = scaleDefaultFilters.filter((filter) => isMonthScaleEnabled || filter.measureType !== 'months');

  // reset timeline store and production plan filter store if months scale is disabled, but is selected in local storage
  useEffect(() => {
    if (!isMonthScaleEnabled && currentFilter.measureType === 'months') {
      useTimelineStore.setState(useTimelineStore.getInitialState());
      useGanttFilterStore.setState(useGanttFilterStore.getInitialState());
    }
  }, [isMonthScaleEnabled, currentFilter]);

  return (
    <DropdownMenu.Root>
      <DropdownMenu.Trigger>
        <Chip
          className="group/trigger mr-2 ml-4"
          label={`${tWrapper('scale')}: ${currentFilter.label}`}
          selected={true}
          EndIcon={
            <>
              <CUSTOM_ICONS.Collapse className="group-data-[state=closed]/trigger:hidden" />
              <CUSTOM_ICONS.Expand className="group-data-[state=open]/trigger:hidden" />
            </>
          }
        />
      </DropdownMenu.Trigger>
      <DropdownMenu.Content className="z-50">
        {filters.map((filter) => (
          <DropdownMenu.Button
            className={cn(currentFilter.label === filter.label && 'bg-surface-focus-lighter')}
            key={filter.label}
            onClick={() => {
              onFilterChange(filter);
              centerCurrentDate();
            }}
          >
            {filter.label}
          </DropdownMenu.Button>
        ))}
      </DropdownMenu.Content>
    </DropdownMenu.Root>
  );
};

TimelineFilterChip.displayName = 'TimelineFilterChip';
